document.addEventListener('DOMContentLoaded', function() {
    // Find all primary buttons
    const primaryButtons = document.querySelectorAll('.btn--primary');
    
    // Add pulse animation to each button
    primaryButtons.forEach(button => {
      // Only add if it doesn't already have a pulse wrap
      if (!button.querySelector('.pulse-wrap')) {
        // Create pulse elements
        const pulseWrap = document.createElement('span');
        pulseWrap.className = 'pulse-wrap';
        
        const pulseDot = document.createElement('span');
        pulseDot.className = 'pulse-dot';
        
        // Add elements to button
        pulseWrap.appendChild(pulseDot);
        button.insertBefore(pulseWrap, button.firstChild);
      }
    });
  });